angular.module('ui.order.orderItemCard', [
    'ui.order.orderItemCard.orderItemCardDataProvider',

    'ui.order.orderItemCard.orderItemActions',
    'ui.order.orderItemCard.orderItemComments',
    'ui.order.orderItemCard.orderItemFiles',
    'ui.order.orderItemCard.orderReports',
    'ui.order.orderItemCard.orderItemInfo'
])

    .directive('orderItemCard', function () {
        return {
            restrict: 'E',
            controller: 'OrderItemCardController',
            controllerAs: 'OrderItemCardController',
            templateUrl: 'app/ui/order/orderItemCard/orderItemCard.html',
            scope: {
                orderItemId: '@orderItemId',

                onLoadStart: '&',
                onLoadEnd: '&',
                onAfterActionExecute: '&',
                onBeforeActionExecute: '&'
            }
        };
    })

    .controller('OrderItemCardController', function ($timeout, $scope, $q, toastr, gettextCatalog, userSettings,
                                                     orderItemCardDataProvider, orderDetailsControllerUpdatesService) {
        $scope.tabs = [
            {
                title: gettextCatalog.getString("Info"),
                name: "info"
            },
            {
                title: gettextCatalog.getString("Notes"),
                name: "notes"
            },
            {
                title: gettextCatalog.getString("Files"),
                name: "files"
            },
            {
                title: gettextCatalog.getString("Reports"),
                name: "reports"
            }
        ];

        _.extend($scope, {
            executeAction: executeAction,
            setCurrentTab: setCurrentTab
        });

        initController();

        function initController() {
            $scope.isHiddenSummary = false;
            //We do need two flags of busyness indication to allow us to inform our components
            //about work being done, but not inform every piece of UI about it, so it will not blink annoyingly
            $scope.isBusyInternal = false;
            $scope.isBusy = false;

            setCurrentTab();
            initData();
            initWatchers();
            initSignalREvents();
        }

        function initData(force) {
            if (!force && $scope.orderItemId === orderItemCardDataProvider.getOrderItemId()) {
                return;
            }

            onLoadStart();
            orderItemCardDataProvider.setOrderItemId($scope.orderItemId, force);
        }

        function initWatchers() {
            orderItemCardDataProvider.onDataChange('OrderItemCardController', function () {
                $scope.orderItemId = orderItemCardDataProvider.getOrderItemId();

                if (!$scope.orderItemId) {
                    $scope.orderItem = null;
                    $scope.step = null;
                    $scope.order = null;
                    $scope.categories = null;
                    $scope.categoryTypes = null;
                } else {
                    $scope.orderItem = orderItemCardDataProvider.getOrderItem();
                    $scope.step = orderItemCardDataProvider.getStep();
                    $scope.order = orderItemCardDataProvider.getOrder();
                    $scope.categories = orderItemCardDataProvider.getCategories();
                    $scope.categoryTypes = orderItemCardDataProvider.getCategoryTypes();
                }

                onLoadEnd();
            });

            $scope.$watch('orderItemId', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    initData();
                }
            });
        }

        function initSignalREvents() {
            orderDetailsControllerUpdatesService.onOrderItemChanged(function (modelInfo) {
                if ($scope.isBusy) {
                    return;
                }

                if ($scope.orderItem && modelInfo.id == $scope.orderItem.getId()) {
                    initData();
                }
            });
        }

        function setCurrentTab(tab) {
            if (!tab) {
                tab = $scope.tabs[0]; // default tab
                if (userSettings.settings.saveOrderItemCardTab === true || userSettings.settings.saveOrderItemCardTab == "true") {
                    var savedTab = _.find($scope.tabs, function (tab) {
                        return tab.name === userSettings.settings.orderItemCardTab;
                    });
                    tab = savedTab || tab;
                }
            }
            $scope.currentTab = tab;
            userSettings.settings.orderItemCardTab = $scope.currentTab.name;
            userSettings.save();
        }

        var actionIsExecuting;

        function executeAction(actionCode) {
            if (actionIsExecuting || $scope.isBusy) {
                return;
            }
            actionIsExecuting = true;
            onLoadStart();

            var unlinkedCategories = _.where($scope.categories, {isLinked: false});
            var linkedCategories = _.where($scope.categories, {isLinked: true});

            onBeforeActionExecute();
            orderItemCardDataProvider.executeAction(actionCode, unlinkedCategories, linkedCategories)

                .then(function () {
                    return onAfterActionExecute();
                }, function () {
                    return onAfterActionExecute();
                })

                .then(function () {
                    actionIsExecuting = false;
                    onLoadEnd();
                    initData(true);
                });
        }

        function onLoadStart() {
            $scope.isBusy = true;
            if ($scope.onLoadStart) {
                $scope.onLoadStart();
            }
        }

        function onLoadEnd() {
            $scope.isBusy = false;
            if ($scope.onLoadEnd) {
                $scope.onLoadEnd();
            }
        }

        function onAfterActionExecute() {
            if ($scope.onAfterActionExecute) {
                return $scope.onAfterActionExecute();
            }
            return $q.when(true);
        }

        function onBeforeActionExecute() {
            if ($scope.onBeforeActionExecute) {
                return $scope.onBeforeActionExecute();
            }
        }

    })

    // Separate service for update events (to prevent multiple event subscription)
    .service('orderDetailsControllerUpdatesService', function (rest) {
        var _this = this;
        var newOrderItemCb;
        var orderItemChangedCb;
        var orderChangedCb;

        rest.events.on("modelCreatedOnServer", function (modelInfo) {
            if (!newOrderItemCb) {
                return;
            }
            if (modelInfo && modelInfo.modelType == "OrderItemModel") {
                newOrderItemCb(modelInfo);
            }
        });

        rest.events.on("modelUpdatedOnServer", function (modelInfo) {
            if (modelInfo.modelType == "OrderItemModel" && orderItemChangedCb) {
                orderItemChangedCb(modelInfo);
            } else if (modelInfo.modelType == "OrderModel" && orderChangedCb) {
                orderChangedCb(modelInfo);
            }
        });

        _this.onNewOrderItem = function (cb) {
            newOrderItemCb = cb;
        };

        _this.onOrderItemChanged = function (cb) {
            orderItemChangedCb = cb;
        };

        _this.onOrderChanged = function (cb) {
            orderChangedCb = cb;
        };

        return _this;
    })

;